import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { AttachmentsList } from "./AttachmentsList.jsx";
import { SelectAttachmentControl } from "./SelectAttachmentControl.jsx";

export const SelectAttachments = ({
  className,
  attachmentIds,
  filesToAttach,
  filesToDrop,
  onChange,
  onOpenFileWindow,
  onAttachFromDropbox,
  onAttachFromGoogleDrive,
  error,
  uploads,
  uploaded,
  onCancelUpload,
  onRetryUpload,
  uploading,
  dropUploadedFile,
}) => {
  const hasAttachments = attachmentIds.size > 0 && attachmentIds.size > filesToDrop.length;
  const hasFiles =
    filesToAttach.length > 0 ||
    hasAttachments ||
    uploading ||
    Object.keys(uploads).length > 0 ||
    Object.keys(uploaded).length > 0;

  return (
    <div className={className}>
      <div className="select_attachments">
        {!hasFiles ? (
          <SelectAttachmentControl
            filesToAttach={filesToAttach}
            openFileWindow={onOpenFileWindow}
            onAttachFromDropbox={onAttachFromDropbox}
            onAttachFromGoogleDrive={onAttachFromGoogleDrive}
          />
        ) : (
          <AttachmentsList
            error={error}
            uploads={uploads}
            uploading={uploading}
            uploaded={uploaded}
            onCancelUpload={onCancelUpload}
            onRetryUpload={onRetryUpload}
            openFileWindow={onOpenFileWindow}
            onAttachFromDropbox={onAttachFromDropbox}
            onAttachFromGoogleDrive={onAttachFromGoogleDrive}
            attachmentIds={attachmentIds}
            filesToAttach={filesToAttach}
            filesToDrop={filesToDrop}
            onChange={onChange}
            dropUploadedFile={dropUploadedFile}
          />
        )}
      </div>
    </div>
  );
};

SelectAttachments.propTypes = {
  attachmentIds: PropTypes.instanceOf(List),
  filesToAttach: PropTypes.arrayOf(PropTypes.string),
  filesToDrop: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func,
  className: PropTypes.string,
  uploads: PropTypes.object,
  onOpenFileWindow: PropTypes.func,
  onAttachFromDropbox: PropTypes.func,
  onAttachFromGoogleDrive: PropTypes.func,
  uploaded: PropTypes.array,
  onCancelUpload: PropTypes.func,
  onRetryUpload: PropTypes.func,
  error: PropTypes.object,
  uploading: PropTypes.bool,
  dropUploadedFile: PropTypes.func,
};

SelectAttachments.defaultProps = {
  attachmentIds: List(),
  filesToAttach: [],
  filesToDrop: [],
  uploads: {},
  uploading: false,
  dropUploadedFile: () => null,
};
